import React from "react";
import ScrollToTop from "./ScrollToTop";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Hero from "./components/Hero";
import CaseStudies from "./components/CaseStudies";
import Contact from "./pages/Contact";
import Footer from "./components/layout/Footer";
import Services from "./pages/Services";
import '@fortawesome/fontawesome-free/css/all.min.css';
import ChatBot from "./components/layout/ChatBot";
import InvestVerse from "./pages/InvestVerse";
import WhyArocoiris from "./components/WhyArocoiris";
import InvestverseSneakPeek from "./pages/InvestverseSneakPeek";
import WaitlistForm from "./pages/WaitlistForm";
import Careers from "./pages/Careers";
import Apply from "./pages/Apply";
import ITServices from "./pages/ITServices";
import TechnologyTransformation from "./pages/TechnologyTransformation";
import TechnologyConsulting from "./pages/TechnologyConsulting";
import HireDevelopers from "./pages/HireDevelopers";
import Training from "./pages/training";
import TrainingRegistration from "./pages/TrainingRegistration";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <Router>
       <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/CaseStudies" element={<CaseStudies />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Investverse" element={<InvestVerse />} />
        <Route path="/investverse-sneakpeek" element={<InvestverseSneakPeek />} />
        <Route path="/waitlist" element={<WaitlistForm />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/apply/:jobTitle" element={<Apply />} />
        <Route path="/services/it-services" element={<ITServices/>} />
        <Route path="/services/transformation" element={<TechnologyTransformation />} />
        <Route path="/services/consulting" element={<TechnologyConsulting />} />
        <Route path="/services/hire-developers" element={<HireDevelopers />} />
        <Route path="/services/training" element={<Training />} />
        <Route path="/training/TrainingRegistration" element={<TrainingRegistration />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />



      </Routes>
      <Footer />
      <ChatBot />
    </Router>
  );
}

export default App;